import React from 'react';

const RadioIndicator = () => {
  return (
    <svg width="16px" height="16px" className="uni-form__radio-indicator" viewBox="0 0 16 16">
      <circle className="uni-form__radio-indicator__outer-border" cx="8" cy="8" r="7" />
      <circle className="uni-form__radio-indicator__empty-space" cx="8" cy="8" r="5" />
      <circle className="uni-form__radio-indicator__inner-circle" cx="8" cy="8" r="3" />
    </svg>
  );
};

export default RadioIndicator;



// WEBPACK FOOTER //
// ./src/forms/__partials/radio-indicator.jsx